import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';

// Hook para detectar si es móvil
function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
}

// Modal principal
const ConfirmModal = ({ isOpen, onClose, onConfirm, dataSKU, dataOfertas }) => {
  const isMobile = useIsMobile();
  const [view, setView] = useState("productos"); // productos | ofertas

  const hasData = dataSKU &&
    dataSKU.skus_cantidad &&
    Object.keys(dataSKU.skus_cantidad).length > 0;

  const hasOfertas = dataOfertas && dataOfertas.length > 0;

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      ariaHideApp={false}
      className={"confirmModal"}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.7)', // Un poco más oscuro para resaltar el modal
          zIndex: 9999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
        content: {
          position: 'relative',
          inset: 'unset', // Quita las posiciones por defecto de ReactModal
          width: isMobile ? '90vw' : '500px',
          maxHeight: '85vh',
          overflow: 'hidden',
          padding: 0,
          borderRadius: '15px',
          border: 'none',
          backgroundColor: '#FFFFFF', // <--- ESTO LE DA EL FONDO BLANCO
          boxShadow: '0 10px 25px rgba(0,0,0,0.2)', // Sombra para dar profundidad
          display: 'flex',
          flexDirection: 'column'
        },
      }}
    >
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        fontFamily: 'Nunito Sans',
        overflowY: 'auto',
        padding: '25px',
        flex: 1,
        minHeight: 0
      }}>
          {/* Confirmación */}
          {view === "productos" && (
              <span style={{ fontWeight: 700, textAlign: 'center' }}>¿Está seguro que desea guardar el siguiente relevamiento?</span>
          )}
        {/* Vista productos */}
        {/* Botones */}
        <div style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'space-evenly',
          gap: '10px',
          marginTop: '10px'
        }}>

          {view === "productos" && (
              <>
                <button
                    className="success"
                    onClick={onConfirm}
                    style={{
                      padding: '10px',
                      borderRadius: '8px',
                      backgroundColor: '#21BDA2',
                      color: '#fff',
                      border: 'none',
                      fontWeight: 600,
                      cursor: 'pointer',
                      width: isMobile ? '100%' : 'auto'
                    }}
                >
                  Confirmar
                </button>
                <button
                    className="cancel"
                    onClick={onClose}
                    style={{
                      padding: '10px',
                      borderRadius: '8px',
                      backgroundColor: '#ccc',
                      border: 'none',
                      fontWeight: 600,
                      cursor: 'pointer',
                      width: isMobile ? '100%' : 'auto'
                    }}
                >
                  Cancelar
                </button>

              </>
          )}
        </div>
        {view === "productos" && (
          hasData ? (
            (() => {
              // obtenemos las keys ordenadas
              const sortedKeys = Object.keys(dataSKU.skus_cantidad).sort((a, b) => {
                const cantidadA = dataSKU.skus_cantidad[a] || 0;
                const cantidadB = dataSKU.skus_cantidad[b] || 0;
                const precioA = dataSKU.skus_precios?.[a] || 0;
                const precioB = dataSKU.skus_precios?.[b] || 0;

                const tieneValorA = cantidadA > 0 || precioA > 0;
                const tieneValorB = cantidadB > 0 || precioB > 0;

                // Los que tienen valores distintos de 0 van primero
                if (tieneValorA && !tieneValorB) return -1;
                if (!tieneValorA && tieneValorB) return 1;
                return 0;
              });
              return isMobile ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '14px' }}>
                  {sortedKeys.map((key) => (
                    <div
                      key={key}
                      style={{
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        padding: '10px',
                        backgroundColor: '#f9f9f9',
                      }}
                    >
                      <div><strong>Producto:</strong> {dataSKU.skus_to_nombre[key]}</div>
                      <div><strong>Cantidad:</strong> {dataSKU.skus_cantidad[key]}</div>
                      <div><strong>Precio:</strong> {dataSKU.skus_precios?.[key] ? `$${dataSKU.skus_precios[key]}` : '-'}</div>
                    </div>
                  ))}
                </div>
              ) : (
                <table style={{ width: '100%', fontSize: '14px', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th style={{ textAlign: 'left' }}>Producto</th>
                      <th>Cantidad</th>
                      <th>Precio</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedKeys.map((key) => (
                      <tr key={key}>
                        <td>{dataSKU.skus_to_nombre[key]}</td>
                        <td>{dataSKU.skus_cantidad[key]}</td>
                        <td>{dataSKU.skus_precios?.[key] ? `$${dataSKU.skus_precios[key]}` : '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              );
            })()
          ) : (
            <p style={{ fontStyle: 'italic', textAlign: 'center' }}>
              No hay productos para mostrar.
            </p>
          )
        )}


        {/* Vista ofertas */}
        {view === "ofertas" && (
          !hasOfertas ? (
            <table style={{ width: '100%', fontSize: '14px', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>Producto</th>
                  <th>Porcentaje</th>
                </tr>
              </thead>
              <tbody>
                {dataOfertas.map((oferta, idx) => (
                  <tr key={idx}>
                    <td>{oferta.producto}</td>
                    <td>{oferta.porcentaje}%</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p style={{ fontStyle: 'italic', textAlign: 'center' }}>No hay ofertas disponibles.</p>
          )
        )}




      </div>
    </ReactModal>
  );
};

export default ConfirmModal;
